(ns app.front.ui.floating-action-bar)

(defn floating-action-bar
  "A centered fixed-position action bar with a default max-width similar to content sections"
  [props & content]
  (into [:div.sticky.z-10.left-0.right-0.mx-auto.bottom-4.lg:bottom-6.rounded.bg-ui-white.border.border-ui-gray.w-full.border-solid.p-1.flex.justify-between.items-center.gap-1.shadow-lg
         (merge props
                {:style (merge {:max-width "1564px"
                                :width     "calc(100% - 32px)"}
                               (:style props))})]
        content))
